const Shopify = {
    "heroSection":{
        "enable": true,
        "title":"SHOPIFY WEB DESIGN SERVICES",
        "subtext":"<strong>Shopify Partners since 2012,</strong> we’re now rated as one of the top rated Shopify developers globally",
        "image": require('../images/shopify/shopify_img-1.png'),
        "class": "move-from-right"
    },
    "statistics": {
        "enable": true,
        "stats": [
            {
                "count": "300+",
                "content": "Projects<br/> across"
            },
            {
                "count": "100+",
                "content": "Talented,<br/> team"
            },
            {
                "count": "1000+",
                "content": "Happy Customers"
            }
        ]
    },
    "textQuoteWithImage":{
        "enable": true,
        "text" :"Our certified Shopify developers have expertise in creating customized Shopify ecommerce stores for all kinds of businesses. We offer end-to-end setup services to launch and manage your online store.",
        "image": require('../images/shopify/shopify_img-2.png'),
        "classes": "bounce-up-down-2",
        "logo": require('../images/client-logos/shopify_plus_logo.png')
    },
    "iconsWithHeadingText": {
        "enable": true,
        "title": "Why Shopify?",
        "subheading": "WE’RE Shopify experts",
        "blocks":[
            {
                "src": require('../svgs/support-2.svg'),
                "heading": "END TO END SETUP",
                "content": "A complete end-to-end setup of services that gets you all you need to launch and manage your new e-commerce store."
            },
            {
                "src": require('../svgs/fully-customised.svg'),
                "heading": "Fully Customized",
                "content": "A fully-functional and easy-to-use e-commerce platform."
            },
            {
                "src": require('../svgs/optimised-web.svg'),
                "heading": "Optimised Websites",
                "content": "An optimized Shopify website development that works to its full potential, made possible thanks to our team’s expertise and experience."
            },
            {
                "src": require('../svgs/unique-functionality.svg'),
                "heading": "Unique Functionality",
                "content": "Unique functionality like creative galleries and more to showcase your products and differentiate yourself from your competition."
            }
        ]
    },
    "services":{
        "enable": true,
        "title": "<strong>We love working,</strong> on custom shopify apps.<br/> Below are some of features.",
        "subheading": "Shopify services",
        "list":["Shopping Cart", "Shipping Returns", "Multi Screen", "Universal Login", "SEO/SEM", "Hosting", "Server Management", "Analytics", "Content Management", "Loyalty & Rewards", "Media", "Social Media", "Alerts & Notifications", "Location & Services"]
    }
};

export default Shopify;